import { createI18n } from 'vue-i18n';

import en from './en';
import es from './es';

export const i18n = createI18n({
	fallbackLocale: 'en',
	legacy: false,
	locale: 'en',
	messages: {
		en,
		es
	}
});
